<template>
    <div
        class="refuse-popup"
    >
        <div class="refuse-popup__item">
            <div class="refuse-popup__item-header">
                <span class="refuse-popup__item-header-title">Не упустите шанс!</span>
                <img
                    class="refuse-popup__item-header-close"
                    src="~@/assets/images/refuse-trip-close.svg"
                    @click="fadePopup(false)"
                >
            </div>
            <div class="refuse-popup__item-content">
                <p class="refuse-popup__item-content-text">
                    Вы попали в <b>0,5% счастливчиков</b>, получивших бесплатную поездку от АНО «Россия – страна возможностей».
                    Таким вознаграждением мы поощряем <b>только самых активных участников</b> наших проектов. Очень жаль, если вы решите не воспользоваться шансом.
                    После отказа от поездки передумать и вернуться к выбору путешествия будет невозможно.
                </p>
                <div class="refuse-popup__item-content-btns">
                    <btn
                        class="refuse-popup__item-content-btn"
                        @click="fadePopup(false)"
                    >
                        Отменить отказ
                    </btn>
                    <btn
                        class="refuse-popup__item-content-btn"
                        outline
                        @click="refuse"
                    >
                        Отказаться
                    </btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import Btn from '@/components/UI/Button';

const actions = [
    'refuseTrip',
];
export default {
    name: 'RefusePopup',
    components: {
        Btn,
    },
    methods: {
        ...mapActions(actions),
        async refuse() {
            await this.refuseTrip();
            this.$router.push({ name: 'account-main' });
        },
        fadePopup(value) {
            this.$emit('fadePopup', value );
        },
    },
};
</script>

<style scoped lang="scss">
    @import '@/styles/rem';
    @import '@/styles/mrem';

    .refuse-popup {
        position: fixed;
        width: 100vw;
        height: 100vh;
        z-index: 1000;
        background: rgba(1, 1, 1, 0.7);
        top: 0;
        left: 0;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;

        &__item {
            background-color: #fff;
            border-radius: mrem(4);
            width: mrem(360);
            height: mrem(554);

            @include on-desktop {
                width: rem(822);
                height: rem(354);
                border-radius: rem(4);
            }

            &-header {
                display: flex;
                justify-content: space-between;
                background-color: #02BF89;
                height: mrem(60);
                border-radius: mrem(4) mrem(4) 0 0;
                padding: mrem(17) mrem(20) mrem(17) mrem(20);
                @include on-desktop {
                    height: rem(60);
                    border-radius: rem(4) rem(4) 0 0;
                    padding: rem(17) rem(20) rem(17) rem(40);
                }

                &-title {
                    font-style: normal;
                    font-weight: bold;
                    font-size: mrem(24);
                    line-height: mrem(26);
                    color: #fff;

                    @include on-desktop {
                        font-size: rem(24);
                        line-height: rem(26);
                    }
                }

                &-close {
                    cursor: pointer;
                }
            }

            &-content {
                padding: mrem(24) mrem(17) 0 mrem(17);

                @include on-desktop {
                    padding: rem(40) rem(40) 0 rem(40);
                }

                &-text {
                    margin: 0 0 mrem(24) 0;
                    font-style: normal;
                    font-weight: normal;
                    font-size: mrem(18);
                    line-height: mrem(26);
                    color: #000000;

                    @include on-desktop {
                        margin: 0 0 rem(24) 0;
                        font-size: rem(18);
                        line-height: rem(26);
                    }
                }

                &-btns {
                    @include on-desktop {
                        display: flex;
                    }
                }

                &-btn {
                    font-style: normal;
                    font-weight: bold;
                    font-size: mrem(18);
                    line-height: mrem(26);
                    padding: mrem(10) mrem(15);
                    background-color: #02BF89;
                    color: #fff;

                    @include on-desktop {
                        font-size: rem(18);
                        line-height: rem(26);
                        padding: rem(10) rem(15);
                    }

                    &:last-child {
                        border: 1px solid #131614;
                        color: #131614;
                        background-color: transparent;
                        margin-top: mrem(24);

                        @include on-desktop {
                            background-color: transparent;
                            margin: 0 0 0 rem(25);
                        }
                    }
                }
            }
        }
    }
</style>